import React, { PureComponent } from 'react';

import ReadMore from './component';

const isOverflowing = element => element.scrollHeight > element.clientHeight;

/**
 * Read More container component.
 * Wraps component with state to control collapsed view, checking for overflowing content.
 */
class ReadMoreContainer extends PureComponent {
  state = {
    // Assume that if the component is being used, "long" content is being provided
    collapsed: true,
  };

  componentDidMount() {
    if (this.element) {
      // Although given the above assumption, it's posssible that the content is not overflowing
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ collapsed: isOverflowing(this.element) });
    }
  }

  handleClick = () => {
    this.setState({ collapsed: false });
  };

  render() {
    return (
      <ReadMore
        onClick={this.handleClick}
        onRef={(element) => {
          this.element = element;
        }}
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default ReadMoreContainer;



// WEBPACK FOOTER //
// ./app/src/components/ReadMore/container.jsx